'use client';

import AppLayout from '@/components/AppLayout';
import PushNotifications from '@/components/PushNotifications';
import { useTheme } from '@/context/ThemeContext';

export default function SettingsPage() {
  const { theme, toggleTheme } = useTheme();

  return (
    <AppLayout>
      <div className="max-w-2xl mx-auto space-y-6">
        <h1 className="text-2xl font-bold text-foreground">Settings</h1>
        <section id="notifications" aria-labelledby="notification-settings-title" className="scroll-mt-20">
          <h2 id="notification-settings-title" className="text-lg font-semibold text-foreground mb-4">Notification settings</h2>
          <PushNotifications />
        </section>
        <section className="bg-card border border-border rounded-xl p-5">
          <h2 className="text-lg font-semibold text-foreground mb-4">Appearance</h2>
          <div className="flex items-center justify-between gap-4">
            <div>
              <p id="dark-mode-label" className="text-sm font-medium text-foreground">Dark mode</p>
              <p className="text-xs text-muted-foreground mt-1">
                {theme === 'dark' ? 'Dark theme is on.' : 'Light theme is on.'} Your choice is saved on this device.
              </p>
            </div>
            <button
              type="button"
              role="switch"
              aria-checked={theme === 'dark'}
              aria-labelledby="dark-mode-label"
              onClick={toggleTheme}
              className={`relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary ${theme === 'dark' ? 'bg-primary' : 'bg-muted border border-border'}`}
            >
              <span className={`h-4 w-4 rounded-full bg-white shadow transition-transform ${theme === 'dark' ? 'translate-x-6' : 'translate-x-1'}`} />
            </button>
          </div>
        </section>
      </div>
    </AppLayout>
  );
}
